'use client'

import { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'

export type SCSSModule = Readonly<Record<string, string>>

export const useDynamicHeaderClass = (styles: SCSSModule) => {
  const [isIntersecting, setIsIntersecting] = useState(true)
  const sentinelReference = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(!!entry?.isIntersecting)
      },
      {
        threshold: 0.5,
      }
    )

    const sentinelNode = sentinelReference.current
    if (sentinelNode) {
      observer.observe(sentinelNode)
    }

    return () => {
      if (sentinelNode) {
        observer.unobserve(sentinelNode)
      }
    }
  }, [])

  const headerClass = classNames({
    [`${styles['header-collapsed']}`]: !isIntersecting,
  })

  return { headerClass, sentinelRef: sentinelReference }
}
